"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var useT_1 = tslib_1.__importDefault(require("./useT"));
/**
 * A component to render a translated string.
 */
var T = function (_a) {
    var count = _a.count, fallback = _a.fallback, interpolations = _a.interpolations, phrase = _a.phrase;
    var t = useT_1.default();
    var tOptions = tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, (fallback && { _: fallback })), (count && { smart_count: count })), interpolations);
    // HACK: A workaround for the current limitations of TSX with FC
    // Ref: https://github.com/DefinitelyTyped/DefinitelyTyped/issues/20544
    return t(phrase, tOptions);
};
exports.default = T;
